import emailjs from "@emailjs/browser";
import { EMAIL_CONTSTANTS } from "../constants/email";

export const sendEmail = ({
  to,
  setSecure,
  price,
  timeline,
  quotes,
  date,
  to_name = "",
  from_name = "Rapid Diligence",
}) => {
  emailjs
    .send(
      EMAIL_CONTSTANTS.serviceID,
      EMAIL_CONTSTANTS.templateID,
      {
        from_name,
        to,
        to_name,
        price,
        timeline,
        quotes,
        date,
      },
      EMAIL_CONTSTANTS.publicKey
    )
    .then(
      (result) => {
        console.log(result.text);
        setSecure(true);
      },
      (error) => {
        console.log(error.text);
        setSecure(error);
        setSecure(false);
      }
    );
};
